import { MapPin, Phone, Mail, Navigation } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { useSite } from "@/lib/site";

export function useContact() {
  const { site } = useSite();
  return site?.contact || {
    address: "8710 Av. du Parc, Montréal", phone_display: "(514) 431-0520", phone_tel: "+15144310520",
    email: "therecroommtl@gmail.com", maps_link: "https://share.google/5P9Shs4KKFxH7jp7J", map_query: "8710 Av. du Parc, Montréal, QC",
  };
}

export function DirectionsButton({ id, className = "" }) {
  const c = useContact();
  const { t } = useLang();
  return (
    <a href={c.maps_link} target="_blank" rel="noopener noreferrer" data-testid={`${id}-directions-btn`}
      className={`btn-chrome inline-flex items-center gap-2 rounded-full px-5 py-3 text-sm font-medium ${className}`}>
      <Navigation size={16} /> {t("hero.directions")}
    </a>
  );
}

export function ContactLines({ id, compact = false }) {
  const c = useContact();
  const row = "flex items-start gap-3 text-slate-200 hover:text-white transition-colors";
  const icon = "mt-0.5 shrink-0 text-red-500";
  return (
    <div className={`flex flex-col ${compact ? "gap-2 text-sm" : "gap-4 text-base"}`}>
      <a href={c.maps_link} target="_blank" rel="noopener noreferrer" className={row} data-testid={`${id}-address-link`}>
        <MapPin size={18} className={icon} /> <span className="underline-offset-4 hover:underline">{c.address}</span>
      </a>
      <a href={`tel:${c.phone_tel}`} className={row} data-testid={`${id}-phone-link`}>
        <Phone size={18} className={icon} /> <span className="font-mono">{c.phone_display}</span>
      </a>
      <a href={`mailto:${c.email}`} className={row} data-testid={`${id}-email-link`}>
        <Mail size={18} className={icon} /> <span className="break-all">{c.email}</span>
      </a>
    </div>
  );
}

export function SectionHead({ eyebrow, title, sub }) {
  return (
    <div className="mb-10 max-w-2xl lg:mb-14">
      <p className="eyebrow mb-3">{eyebrow}</p>
      <h2 className="font-display text-4xl uppercase text-white sm:text-5xl">{title}</h2>
      {sub && <p className="mt-4 text-base text-slate-400 md:text-lg">{sub}</p>}
    </div>
  );
}
